import React from 'react';

const GroupChatLargeIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.3236 14.3192C20.1731 14.3192 19.0697 13.8621 18.2562 13.0486C17.4426 12.235 16.9856 11.1316 16.9856 9.98111C16.9856 8.83059 17.4426 7.72719 18.2562 6.91365C19.0697 6.10011 20.1731 5.64307 21.3236 5.64307C22.4742 5.64307 23.5776 6.10011 24.3911 6.91365C25.2046 7.72719 25.6617 8.83059 25.6617 9.98111C25.6617 11.1316 25.2046 12.235 24.3911 13.0486C23.5776 13.8621 22.4742 14.3192 21.3236 14.3192Z"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M12.6477 27.3333V26.2488C12.6477 24.523 13.3333 22.8679 14.5536 21.6476C15.7739 20.4273 17.429 19.7417 19.1548 19.7417H23.4928C25.2186 19.7417 26.8737 20.4273 28.094 21.6476C29.3143 22.8679 29.9999 24.523 29.9999 26.2488V27.3333"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M6.69084 9.47053C6.01043 8.79011 5.62817 7.86727 5.62817 6.90502C5.62817 5.94277 6.01043 5.01993 6.69084 4.33952C7.37125 3.65911 8.29409 3.27686 9.25634 3.27686C10.2186 3.27686 11.1414 3.65911 11.8218 4.33952"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M2 21.4177V20.5106C2 19.0672 2.57338 17.683 3.594 16.6624C4.61462 15.6417 5.99888 15.0684 7.44225 15.0684H9.25634"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default GroupChatLargeIcon;
